// composite-work-enterprise page bundle -> dist/js/pages/composite-work-enterprise.min.js
//
// Plain-ES port of the v3 Composite Workforce Enterprise (CWE) interactions. The
// authoritative source is the component the running :8015 render embeds in-page
// as a <script type="text/x-dc"> — which is AHEAD of the committed
// dc/composite-work-enterprise.logic.js (that stale copy still has the old
// "Cond" condition and heroSpeed props). The :8015 version wins; this is a
// faithful vanilla port of it. Props are hardcoded to the v3 render defaults
// (heroDensity 1, heroHandoffs true, workforceStart 'today').
//
// The body markup is identical at every width (the 1780 and 390 captures matched
// tag-for-tag), so there is no SSR width branch: the same DOM is served and the
// layout functions (layoutWeek, layoutMarks) recompute positions
// from the live lane geometry at whatever width the page loaded. Every diagram
// reveals through one IntersectionObserver + scroll-sweep pass; every clickable
// control (the three condition dots, the two distribution buttons, the four
// position tabs) is wired.
//
// Nav auto-hide, the dropdown panels and the mobile menu are the shared header's
// job and live in chrome.js — this file does not touch them.

(function () {
  "use strict";

  var root = document.querySelector(".pe-cwe");
  if (!root) return;

  var $ = function (sel, ctx) { return (ctx || root).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); };
  var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ------------------------------ data ------------------------------ */
  // 18 tasks in one team. 'keep' stays with a person; 'move' starts with a
  // person and ends with an agent; 'agent' was always an agent; 'unchecked'
  // moved and nobody is answerable for it.
  var WEEK = ['keep','keep','keep','move','keep','keep','agent','keep','keep','move','keep','keep','keep','unchecked','keep','keep','keep','keep'];
  var COND_NOTES = [
    { hit: 'move' },
    { hit: 'unchecked' },
    { hit: 'all' }
  ];
  // 21 tasks, and where they sit in each distribution.
  var DIST = {
    now:  ['above','above','above','in','in','in','in','in','in','in','in','in','in','below','below','below','below','below','below','make','make'],
    next: ['above','above','above','above','above','in','in','in','in','in','in','below','below','below','below','below','below','below','below','make','make']
  };
  var NOTE = {
    now:  'Most tasks still sit with people, and the agents that already exist were never placed there deliberately.',
    next: 'Volume moves below the loop. Judgement stays with people — and more of it moves above the loop, to running the system.'
  };

  /* ------------------------------ state ------------------------------ */
  var heroEl = $("#cwe-hero");
  var cv = heroEl ? ($("[data-cv]", heroEl) || heroEl.querySelector("canvas")) : null;
  var condEl = $("#cwe-condition");
  var loopEl = $("#cwe-workforce");

  var dist = (workforceStartProp() === 'as work moves') ? 'next' : 'now';
  // Default the selected position to the FIRST tab as rendered (the CMS-driven
  // order), not a hardcoded 'above' — otherwise reordering the positions in the
  // CMS would render the first tile selected server-side but snap back to
  // 'above' on load.
  var firstPos = loopEl ? $("[data-pos]", loopEl) : null;
  var pos = firstPos ? (firstPos.getAttribute("data-pos") || 'above') : 'above';
  var note = 0;
  var weekMoved = false;
  var noteHeld = false;
  var noteT = null;
  function workforceStartProp() { return 'today'; } // v3 default

  var pending = [];
  var io = null;

  /* --------------------------- reveal plumbing --------------------------- */
  function arm() {
    if (!io && !reduced && "IntersectionObserver" in window) {
      io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.unobserve(e.target);
          enter(e.target);
        });
      }, { threshold: 0.14, rootMargin: "0px 0px -6% 0px" });
    }
    $$("[data-rise],[data-play]").forEach(function (el) {
      if (el.__armed) return;
      el.__armed = true;
      if (reduced) { enter(el); return; }
      pending.push(el);
      if (io) io.observe(el);
    });
    sweep();
  }

  function enter(el) {
    if (el.__entered) return;
    el.__entered = true;
    if (el.hasAttribute("data-rise")) {
      if (!el.__risen) {
        el.__risen = true;
        var kin = el.parentElement ? Array.prototype.slice.call(el.parentElement.children) : [];
        var sibs = kin.filter(function (s) { return s.hasAttribute && s.hasAttribute("data-rise"); });
        var i = Math.max(0, sibs.indexOf(el));
        el.style.transitionDelay = reduced ? "0ms" : (i * 110) + "ms";
      }
      el.style.opacity = "1";
      el.style.transform = "none";
    }
    var key = el.getAttribute("data-play");
    if (key) play(key, el, !reduced);
  }

  // scroll fallback: some embedded views never deliver observer callbacks
  function sweep() {
    if (!pending.length) return;
    var h = window.innerHeight;
    pending = pending.filter(function (el) {
      if (el.__entered) return false;
      var r = el.getBoundingClientRect();
      if (r.top < h * 0.9 && r.bottom > 0) { enter(el); return false; }
      return true;
    });
  }

  function play(key, el, st) {
    var fn = PLAYS[key];
    if (fn) fn(st, el);
  }

  /* --------------------- 01 one team, 18 tasks, two owners --------------- */
  function weekBox() {
    if (!condEl) return null;
    var box = $("[data-week]", condEl);
    if (!box) return null;
    var br = box.getBoundingClientRect();
    var lanes = {};
    $$("[data-wlane]", box).forEach(function (l) {
      var r = l.getBoundingClientRect();
      lanes[l.getAttribute("data-wlane")] = { y: r.top - br.top + r.height / 2 };
    });
    return { box: box, w: br.width, lanes: lanes };
  }

  // every task keeps its own column, so a task that moves owner drops to the
  // lane below and leaves its slot empty
  function layoutWeek() {
    var ctx = weekBox();
    if (!ctx || !ctx.lanes.human || !ctx.lanes.agent) return;
    var n = WEEK.length;
    var size = winW() < 640 ? 11 : (winW() < 1024 ? 13 : 16);
    var col = ctx.w / n;
    var yA = ctx.lanes.human.y, yB = ctx.lanes.agent.y;
    WEEK.forEach(function (flag, i) {
      var cx = col * (i + 0.5);
      var isAgent = flag === 'agent' || ((flag === 'move' || flag === 'unchecked') && weekMoved);
      var mark = $('[data-wmark="' + i + '"]', ctx.box);
      if (mark) {
        mark.style.width = size + "px";
        mark.style.height = size + "px";
        mark.style.transform = "translate(" + Math.round(cx - size / 2) + "px," + Math.round((isAgent ? yB : yA) - size / 2) + "px)";
      }
      var ghost = $('[data-ghost="' + i + '"]', ctx.box);
      if (ghost) {
        ghost.style.width = size + "px";
        ghost.style.height = size + "px";
        ghost.style.transform = "translate(" + Math.round(cx - size / 2) + "px," + Math.round(yA - size / 2) + "px)";
      }
      var trail = $('[data-trail="' + i + '"]', ctx.box);
      if (trail) {
        trail.style.height = Math.round(yB - yA) + "px";
        trail.style.transform = "translate(" + Math.round(cx) + "px," + Math.round(yA) + "px) scaleY(" + (weekMoved ? 1 : 0) + ")";
      }
    });
  }

  function playWeek(st, node) {
    if (!node) return;
    layoutWeek();
    var marks = $$("[data-wmark]", node);
    marks.forEach(function (m, i) {
      m.style.transitionDelay = st ? (140 + i * 38) + "ms" : "0ms";
      m.style.opacity = "1";
    });
    var settle = st ? 140 + marks.length * 38 + 500 : 0;
    var go = function () {
      weekMoved = true;
      marks.forEach(function (m) { m.style.transitionDelay = "0ms"; });
      layoutWeek();
      $$("[data-wmark]", node).forEach(function (m) {
        var flag = m.getAttribute("data-flag");
        if (flag !== 'agent' && flag !== 'move' && flag !== 'unchecked') return;
        var shape = m.querySelector("[data-shape]");
        if (shape) {
          shape.style.borderRadius = "0";
          shape.style.transform = "rotate(45deg) scale(.86)";
          shape.style.background = "#F2673A";
          shape.style.borderColor = "#F2673A";
        }
        if (flag === 'unchecked') {
          var ring = m.querySelector("[data-ring]");
          if (ring) setTimeout(function () { ring.style.borderColor = "rgba(242,103,58,.55)"; }, st ? 700 : 0);
        }
      });
      $$("[data-ghost]", node).forEach(function (g) {
        var f = g.getAttribute("data-moved");
        g.style.opacity = (f === "true" || f === true) ? "1" : "0";
      });
      $$("[data-trail]", node).forEach(function (t) {
        var f = t.getAttribute("data-moved");
        t.style.opacity = (f === "true" || f === true) ? "1" : "0";
      });
    };
    if (st) setTimeout(go, settle); else go();

    if (st && !noteT) {
      setTimeout(function () { applyNote(); }, settle + 900);
      noteT = setInterval(function () {
        if (noteHeld) return;
        note = (note + 1) % COND_NOTES.length;
        applyNote();
      }, 5600);
    } else {
      applyNote();
    }
  }

  function applyNote() {
    if (!condEl) return;
    $$("[data-note]", condEl).forEach(function (n) {
      var on = parseInt(n.getAttribute("data-note"), 10) === note;
      n.style.opacity = on ? "1" : "0";
      n.style.transform = on ? "none" : "translateY(8px)";
    });
    $$("[data-dot]", condEl).forEach(function (d) {
      var on = parseInt(d.getAttribute("data-dot"), 10) === note;
      var bar = d.querySelector("[data-dot-bar]");
      if (bar) bar.style.background = on ? "#F2673A" : "rgba(23,114,111,.2)";
    });
    var hit = (COND_NOTES[note] || {}).hit;
    $$("[data-wmark]", condEl).forEach(function (m) {
      var flag = m.getAttribute("data-flag");
      var ring = m.querySelector("[data-ring]");
      var on = hit === 'all' ? false : (flag === hit);
      if (ring) ring.style.transform = on ? "scale(1.18)" : "scale(1)";
      var shape = m.querySelector("[data-shape]");
      if (shape && (flag === 'move' || flag === 'unchecked' || flag === 'agent')) {
        shape.style.transform = on ? "rotate(45deg) scale(1.08)" : "rotate(45deg) scale(.86)";
      }
    });
  }

  /* ------------------------- 02 roles break into tasks ------------------- */
  function playRoles(st, node) {
    if (!node) return;
    $$("[data-row]", node).forEach(function (row, ri) {
      var bar = row.querySelector("[data-bar]");
      var axis = row.querySelector("[data-axis]");
      var marks = $$("[data-mark]", row);
      var base = st ? 240 + ri * 260 : 0;
      if (bar) {
        bar.style.transitionDelay = base + "ms";
        bar.style.transform = "scaleX(1)";
        setTimeout(function () { bar.style.opacity = "0"; }, st ? base + 640 : 0);
      }
      if (axis) {
        axis.style.transitionDelay = st ? (base + 500) + "ms" : "0ms";
        axis.style.opacity = "1";
      }
      marks.forEach(function (m, i) {
        var x = parseFloat(m.getAttribute("data-x")) || 0;
        m.style.transitionDelay = (st ? base + 640 + i * 60 : 0) + "ms";
        m.style.left = (6 + x * 88) + "%";
        m.style.opacity = "1";
        var tag = m.querySelector("[data-tag]");
        if (tag) {
          if (x > 0.66) {
            tag.style.left = "auto"; tag.style.right = "0";
            tag.style.transform = "none"; tag.style.textAlign = "right";
          } else if (x < 0.34) {
            tag.style.left = "0"; tag.style.right = "auto";
            tag.style.transform = "none"; tag.style.textAlign = "left";
          }
        }
      });
    });
    var th = node.querySelector("[data-thresh]");
    if (th) {
      th.style.transitionDelay = st ? "1900ms" : "0ms";
      th.style.opacity = "1";
    }
  }

  /* ---------------------- 03 the composite workforce -------------------- */
  function lanesOf() {
    if (!loopEl) return null;
    var box = $("[data-diagram]", loopEl);
    if (!box) return null;
    var br = box.getBoundingClientRect();
    var rects = {};
    $$("[data-lane]", loopEl).forEach(function (l) {
      var r = l.getBoundingClientRect();
      rects[l.getAttribute("data-lane")] = {
        x: r.left - br.left, y: r.top - br.top, w: r.width, h: r.height
      };
    });
    return { box: box, rects: rects };
  }

  // Position the 21 task marks into their lanes for the current distribution
  // and pick the human/agent glyph per lane (below = agent). Ported from the
  // redesign's layoutMarks.
  function layoutMarks() {
    var ctx = lanesOf();
    if (!ctx) return;
    var marks = $$("[data-mark]", ctx.box);
    if (!marks.length) return;
    var size = winW() < 620 ? 15 : 18;
    var plan = DIST[dist] || DIST.now;
    var groups = {};
    plan.forEach(function (lane, i) { (groups[lane] = groups[lane] || []).push(i); });
    Object.keys(groups).forEach(function (lane) {
      var r = ctx.rects[lane];
      if (!r) return;
      var ids = groups[lane];
      var n = ids.length;
      var gap = Math.min(46, Math.max(size + 5, (r.w - size) / Math.max(1, n - 1)));
      var span = gap * (n - 1);
      var start = r.x + Math.max(0, (r.w - span) / 2);
      var cy = r.y + r.h / 2;
      ids.forEach(function (id, k) {
        var el = marks[id];
        if (!el) return;
        el.style.transform = "translate(" + Math.round(start + gap * k - size / 2) + "px," + Math.round(cy - 10) + "px)";
        var h = el.querySelector('[data-g="h"]');
        var a = el.querySelector('[data-g="a"]');
        var bot = lane === 'below';
        if (h) h.style.opacity = bot ? "0" : "1";
        if (a) a.style.opacity = bot ? "1" : "0";
      });
    });
    applyPosMarks();
  }

  function applyDist() {
    if (!loopEl) return;
    var plan = DIST[dist] || DIST.now;
    var counts = {};
    plan.forEach(function (l) { counts[l] = (counts[l] || 0) + 1; });
    $$("[data-count]", loopEl).forEach(function (c) {
      var k = c.getAttribute("data-count");
      c.textContent = (counts[k] || 0) + " / 21";
    });
    $$("[data-prop]", loopEl).forEach(function (p) {
      var k = p.getAttribute("data-prop");
      p.style.width = Math.round(((counts[k] || 0) / plan.length) * 100) + "%";
    });
    $$("[data-dist]", loopEl).forEach(function (b) {
      var on = b.getAttribute("data-dist") === dist;
      b.style.color = on ? "#fff" : "rgba(255,255,255,.45)";
      b.style.borderBottomColor = on ? "#F2673A" : "transparent";
    });
    var noteEl = $("[data-dist-note]", loopEl);
    if (noteEl) noteEl.textContent = NOTE[dist];
    layoutMarks();
  }

  function playLoop(st, node) {
    if (!node) return;
    layoutMarks();
    $$("[data-mark]", node).forEach(function (m, i) {
      m.style.transitionDelay = st ? (180 + i * 40) + "ms" : "0ms";
      m.style.opacity = "1";
      if (st) setTimeout(function () { m.style.transitionDelay = "0ms"; }, 180 + i * 40 + 900);
    });
  }

  // The tabs and the lanes are one object: the selected position lights its own
  // tab (background, accent border, expanded body), its own lane row and its
  // own marks, and dims the rest. Ported from the redesign's applyPos.
  function applyPos() {
    if (!loopEl) return;
    $$("[data-pos]", loopEl).forEach(function (b) {
      var on = b.getAttribute("data-pos") === pos;
      var num = b.querySelector("[data-pos-num]");
      var title = b.querySelector("[data-pos-title]");
      var body = b.querySelector("[data-pos-body]");
      b.style.background = on ? "rgba(127,211,216,.13)" : "rgba(255,255,255,.04)";
      b.style.borderLeftColor = on ? "#F2673A" : "rgba(255,255,255,.14)";
      if (num) num.style.color = on ? "#F2673A" : "rgba(255,255,255,.4)";
      if (title) title.style.color = on ? "#fff" : "rgba(255,255,255,.74)";
      if (body) {
        body.style.maxHeight = on ? "150px" : "0px";
        body.style.opacity = on ? "1" : "0";
      }
      b.setAttribute("aria-selected", on ? "true" : "false");
    });
    $$("[data-lane-row]", loopEl).forEach(function (r) {
      var on = r.getAttribute("data-lane-row") === pos;
      r.style.background = on ? "rgba(127,211,216,.11)" : "transparent";
      r.style.borderLeftColor = on ? "#F2673A" : "rgba(255,255,255,.12)";
      r.style.opacity = on ? "1" : ".62";
      var lab = r.querySelector("[data-lane-label]");
      var num = r.querySelector("[data-lane-num]");
      if (lab) lab.style.color = on ? "#7FD3D8" : "rgba(255,255,255,.78)";
      if (num) num.style.color = on ? "#F2673A" : "rgba(255,255,255,.38)";
    });
    applyPosMarks();
  }

  function applyPosMarks() {
    var ctx = lanesOf();
    if (!ctx) return;
    var plan = DIST[dist] || DIST.now;
    $$("[data-mark]", ctx.box).forEach(function (m, i) {
      var on = plan[i] === pos;
      m.style.filter = on ? "none" : "saturate(.5)";
      var h = m.querySelector('[data-g="h"]');
      var a = m.querySelector('[data-g="a"]');
      var dim = on ? "1" : ".5";
      if (h && h.style.opacity !== "0") h.style.opacity = dim;
      if (a && a.style.opacity !== "0") a.style.opacity = dim;
    });
  }

  /* --------------------- 04 four stakeholders, one plan ----------------- */
  function playAlign(st, node) {
    if (!node) return;
    $$("[data-exec]", node).forEach(function (x, i) {
      x.style.transitionDelay = st ? (150 + i * 150) + "ms" : "0ms";
      x.style.opacity = "1";
      x.style.transform = "none";
    });
    var join = node.querySelector("[data-join]");
    var stem = node.querySelector("[data-stem]");
    var plan = node.querySelector("[data-plan]");
    if (join) { join.style.transitionDelay = st ? "780ms" : "0ms"; join.style.transform = "scaleX(1)"; }
    if (stem) { stem.style.transitionDelay = st ? "1400ms" : "0ms"; stem.style.transform = "scaleY(1)"; }
    if (plan) {
      // The AOP box comes in right with the exec seats now (the old join/stem
      // lines it used to wait behind are retired), so it no longer appears late.
      plan.style.transitionDelay = st ? "600ms" : "0ms";
      plan.style.opacity = "1";
      plan.style.transform = "none";
    }
  }

  /* --------------------------- the sequence (How it runs) --------------- */
  // Single horizontal timeline: the progress line fills, the centre divider and
  // the "operating plan signed" gate fade in, and the six moves reveal in order.
  function playPhase(st, p) {
    if (!p) return;
    var prog = p.querySelector("[data-progress]");
    if (prog) {
      prog.style.transitionDelay = st ? "200ms" : "0ms";
      prog.style.width = "100%";
    }
    var divider = p.querySelector("[data-seqdivider]");
    if (divider) { divider.style.transitionDelay = st ? "500ms" : "0ms"; divider.style.opacity = "1"; }
    var gate = p.querySelector("[data-gate]");
    if (gate) { gate.style.transitionDelay = st ? "700ms" : "0ms"; gate.style.opacity = "1"; }
    $$("[data-step]", p).forEach(function (s, i) {
      s.style.transitionDelay = st ? (300 + i * 150) + "ms" : "0ms";
      s.style.opacity = "1";
      s.style.transform = "none";
    });
  }

  /* ------------------------------ 06 outcomes --------------------------- */
  function playChain(st, node) {
    if (!node) return;
    $$("[data-link]", node).forEach(function (l, i) {
      l.style.transitionDelay = st ? (i * 120) + "ms" : "0ms";
      l.style.opacity = "1";
      l.style.transform = "none";
    });
  }

  var PLAYS = {
    Week: playWeek, Roles: playRoles, Loop: playLoop,
    Align: playAlign, Phase: playPhase, Chain: playChain
  };

  /* ------------------ hero canvas: pyramid -> tasks -> human/agent layers ---
   * Ported from the 2026-08 CWE redesign ("Composite Workforce Enterprise.html"):
   * the org pyramid dissolves as each role breaks into its tasks; the tasks
   * scatter across the field, then recompose into four stacked layers — people
   * above/in the loop, orange agent-bots below, and the people who create AI.
   * A 15s loop; reduced motion shows one static frame. This supersedes the
   * earlier org-tree build-in (the redesign replaces it). */
  var ctx2 = null, dpr = 1, cw = 1, ch = 1;
  var raf = null, run = true, t0 = 0;
  var tok = [], task = [], laneY = {}, per = 3;
  var TEAL = "23,114,111";

  function winW() { return window.innerWidth; }

  function layoutCanvas() {
    if (!cv) return;
    var r = cv.getBoundingClientRect();
    dpr = Math.min(2, window.devicePixelRatio || 1);
    cv.width = Math.max(1, Math.round(r.width * dpr));
    cv.height = Math.max(1, Math.round(r.height * dpr));
    cw = r.width;
    ch = r.height;
  }

  // Build the pyramid (tok), the scattered task field (task) and the four lane
  // Y positions from the current canvas size. Deterministic, so a resize
  // rebuilds to the same shape; the build/dissolve/recompose is time-based in
  // heroFrame() off a shared t0, so a resize never replays it from the start.
  function seed() {
    var W = cw, H = ch;
    var plan = DIST.now, N = plan.length;

    // pyramid — six ranks of the org chart, one figure per role
    var rows = [1, 2, 3, 4, 5, 6];
    var rowGap = Math.min(H * 0.118, 50);
    var stepX = Math.min(W * 0.086, 56);
    var apexY = H * 0.5 - rowGap * 2.6;
    var pyr = [];
    rows.forEach(function (count, ri) {
      for (var k = 0; k < count; k++) {
        pyr.push({ x: W * 0.5 + (k - (count - 1) / 2) * stepX, y: apexY + ri * rowGap, row: ri, k: k, count: count });
      }
    });

    // layers — the four positions, in order, one glyph per role
    var order = ["above", "in", "below", "make"];
    var byLane = { above: [], in: [], below: [], make: [] };
    plan.forEach(function (l, i) { byLane[l].push(i); });
    laneY = {};
    order.forEach(function (l, i) { laneY[l] = H * (0.185 + i * 0.208); });
    var layer = new Array(N);
    order.forEach(function (l) {
      var ids = byLane[l];
      var gap = Math.min(36, (W * 0.74) / Math.max(1, ids.length - 1));
      var span = gap * (ids.length - 1);
      ids.forEach(function (id, k) { layer[id] = { x: W * 0.5 - span / 2 + gap * k, y: laneY[l], lane: l }; });
    });

    // every role breaks into three tasks that scatter across a loose field
    per = 3;
    var cols = 9, rowsT = Math.ceil(N * per / cols);
    var fieldW = W * 0.84, fieldH = H * 0.7;
    var cellW = fieldW / cols, cellH = fieldH / Math.max(1, rowsT - 1);
    tok = [];
    task = [];
    for (var i = 0; i < N; i++) {
      var p = pyr[i % pyr.length];
      tok.push({ px: p.x, py: p.y, prow: p.row, pk: p.k, pcount: p.count, lx: layer[i].x, ly: layer[i].y, lane: layer[i].lane });
      for (var k2 = 0; k2 < per; k2++) {
        var id = i * per + k2;
        var cx = id % cols, cy = Math.floor(id / cols);
        var j1 = ((id * 0.6180339887) % 1) - 0.5;
        var j2 = ((id * 0.7548776662) % 1) - 0.5;
        task.push({
          owner: i,
          bx: p.x + (k2 - 1) * 15, by: p.y + 15,
          sx: W * 0.08 + cellW * (cx + 0.5) + j1 * cellW * 0.42,
          sy: H * 0.15 + cellH * cy + j2 * cellH * 0.3,
          lx: layer[i].x, ly: layer[i].y
        });
      }
    }
  }

  // thin stick figure (a person / role)
  function drawPerson(x, y, s, a) {
    ctx2.strokeStyle = "rgba(" + TEAL + "," + Math.min(1, a * 0.85).toFixed(3) + ")";
    ctx2.lineWidth = 1.3;
    ctx2.lineCap = "round";
    var hr = s * 0.19, top = y - s * 0.5;
    ctx2.beginPath();
    ctx2.arc(x, top + hr, hr, 0, 6.2832);
    ctx2.stroke();
    ctx2.beginPath();
    ctx2.moveTo(x, top + hr * 2);
    ctx2.lineTo(x, y + s * 0.12);
    ctx2.moveTo(x - s * 0.28, y - s * 0.1);
    ctx2.lineTo(x + s * 0.28, y - s * 0.1);
    ctx2.moveTo(x, y + s * 0.12);
    ctx2.lineTo(x - s * 0.24, y + s * 0.5);
    ctx2.moveTo(x, y + s * 0.12);
    ctx2.lineTo(x + s * 0.24, y + s * 0.5);
    ctx2.stroke();
  }

  // an agent "bot" glyph (orange), for the below-the-loop layer
  function drawBot(x, y, s, a) {
    var c = "rgba(242,103,58," + Math.min(1, a * 0.92).toFixed(3) + ")";
    ctx2.strokeStyle = c;
    ctx2.fillStyle = c;
    ctx2.lineWidth = 1.3;
    var w = s * 0.78, h = s * 0.6, r = s * 0.16;
    var l = x - w / 2, t = y - h / 2 + s * 0.06;
    ctx2.beginPath();
    ctx2.moveTo(x, t - s * 0.24);
    ctx2.lineTo(x, t);
    ctx2.stroke();
    ctx2.beginPath();
    if (ctx2.roundRect) ctx2.roundRect(l, t, w, h, r); else ctx2.rect(l, t, w, h);
    ctx2.stroke();
    ctx2.beginPath();
    ctx2.arc(x - w * 0.22, t + h * 0.45, 1.2, 0, 6.2832);
    ctx2.arc(x + w * 0.22, t + h * 0.45, 1.2, 0, 6.2832);
    ctx2.fill();
  }

  // a hollow task square
  function drawTask(x, y, s, a) {
    ctx2.strokeStyle = "rgba(" + TEAL + "," + Math.min(1, a * 0.6).toFixed(3) + ")";
    ctx2.lineWidth = 1;
    ctx2.strokeRect(x - s / 2, y - s / 2, s, s);
  }

  function initCanvas() {
    if (!cv) return;
    ctx2 = cv.getContext("2d");
    if (!ctx2) return;
    layoutCanvas();
    seed();
    t0 = (window.performance || Date).now();
    if (reduced) { heroFrame(4200); return; }
    run = true;
    if (heroEl && "IntersectionObserver" in window) {
      var obs = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          run = e.isIntersecting;
          if (run && !raf) loop();
        });
      }, { threshold: 0.02 });
      obs.observe(heroEl);
    }
    loop();
  }

  function loop() {
    raf = requestAnimationFrame(function () {
      raf = null;
      var now = (window.performance || Date).now();
      var tt = (now - t0) % 15000;
      heroFrame(tt);
      if (run) loop();
    });
  }

  function heroFrame(tt) {
    if (!ctx2 || !tok.length) return;
    var d = dpr || 1, W = cw || 1, H = ch || 1;
    ctx2.setTransform(d, 0, 0, d, 0, 0);
    ctx2.clearRect(0, 0, W, H);

    var cl = function (v) { return Math.max(0, Math.min(1, v)); };
    var ez = function (v) { return v < 0.5 ? 2 * v * v : 1 - Math.pow(-2 * v + 2, 2) / 2; };
    var gA = ez(cl(tt / 1400)) * (1 - cl((tt - 13600) / 1100));
    var decG = ez(cl((tt - 3200) / 3000));
    var recG = ez(cl((tt - 7900) / 3000));
    var s = Math.max(11, Math.min(19, W * 0.042));

    // hierarchy lines: the pyramid's structure, dissolving as work breaks up
    var lA = gA * (1 - decG) * 0.5;
    if (lA > 0.01) {
      ctx2.strokeStyle = "rgba(" + TEAL + "," + lA.toFixed(3) + ")";
      ctx2.lineWidth = 1.6;
      tok.forEach(function (t) {
        if (t.prow === 0) return;
        var parent = null;
        for (var q = 0; q < tok.length; q++) {
          var o = tok[q];
          if (o.prow === t.prow - 1 && o.pk === Math.min(t.pk, o.pcount - 1) && Math.abs(o.pk - t.pk) <= 1) { parent = o; break; }
        }
        if (!parent) return;
        ctx2.beginPath();
        ctx2.moveTo(t.px, t.py - s * 0.55);
        ctx2.lineTo(parent.px, parent.py + s * 0.5);
        ctx2.stroke();
      });
    }

    // the four layer rules, drawn only as the work recomposes
    if (recG > 0.02) {
      ctx2.strokeStyle = "rgba(" + TEAL + "," + (gA * recG * 0.22).toFixed(3) + ")";
      ctx2.lineWidth = 1.6;
      Object.keys(laneY).forEach(function (k) {
        var y = laneY[k] + s * 0.95;
        ctx2.beginPath();
        ctx2.moveTo(W * 0.07, y);
        ctx2.lineTo(W * 0.93, y);
        ctx2.stroke();
      });
    }

    // stage 2 — each role splits into tasks that scatter, then recompose
    task.forEach(function (k, i) {
      var o = k.owner;
      var burst = ez(cl((tt - 3200 - o * 105) / 700));
      var dec = ez(cl((tt - 3500 - o * 105) / 1900));
      var rec = ez(cl((tt - 7900 - i * 26) / 2000));
      if (burst < 0.02 || rec >= 1) return;
      var t = tok[o];
      var x = t.px + (k.bx - t.px) * burst, y = t.py + (k.by - t.py) * burst;
      x += (k.sx - x) * dec; y += (k.sy - y) * dec;
      x += (k.lx - x) * rec; y += (k.ly - y) * rec;
      var tA = gA * burst * (1 - Math.max(dec, rec)) * 0.5;
      if (tA > 0.03) {
        ctx2.strokeStyle = "rgba(" + TEAL + "," + tA.toFixed(3) + ")";
        ctx2.lineWidth = 1.6;
        ctx2.beginPath();
        ctx2.moveTo(t.px, t.py + s * 0.2);
        ctx2.lineTo(x, y);
        ctx2.stroke();
      }
      drawTask(x, y, s * 0.4, gA * burst * (1 - rec));
    });

    // stage 1 & 3 — the figure, then the glyph it becomes in its layer
    tok.forEach(function (t, i) {
      var dec = ez(cl((tt - 3200 - i * 105) / 900));
      var rec = ez(cl((tt - 8400 - i * per * 26) / 1400));
      var isBot = t.lane === "below" ? 1 : 0;
      var aPerson = gA * Math.max(1 - dec, rec * (1 - isBot));
      var aBot = gA * rec * isBot;
      var x = rec > 0 ? t.lx : t.px, y = rec > 0 ? t.ly : t.py;
      if (aPerson > 0.02) drawPerson(x, y, s, aPerson);
      if (aBot > 0.02) drawBot(x, y, s, aBot);
    });
  }

  /* ------------------------------ controls ------------------------------ */
  // condition annotation dots: pick one and hold it
  if (condEl) {
    $$("[data-dot]", condEl).forEach(function (d) {
      d.addEventListener("click", function () {
        note = parseInt(d.getAttribute("data-dot"), 10) || 0;
        noteHeld = true;
        applyNote();
      });
    });
  }

  if (loopEl) {
    // distribution toggle: Today / As work moves
    $$("[data-dist]", loopEl).forEach(function (b) {
      b.addEventListener("click", function () {
        dist = b.getAttribute("data-dist");
        applyDist();
      });
    });
    // the four position tabs: hover, focus or click selects the position
    var posEnter = function (b) {
      pos = b.getAttribute("data-pos");
      applyPos();
    };
    $$("[data-pos]", loopEl).forEach(function (b) {
      b.addEventListener("mouseenter", function () { posEnter(b); });
      b.addEventListener("focus", function () { posEnter(b); });
      b.addEventListener("click", function () { posEnter(b); });
    });
  }

  /* --------------------------- boot + listeners ------------------------- */
  window.addEventListener("scroll", function () { sweep(); }, { passive: true });

  var rzT = null;
  window.addEventListener("resize", function () {
    window.clearTimeout(rzT);
    rzT = window.setTimeout(function () {
      layoutCanvas();
      seed();
      layoutWeek();
      layoutMarks();
    }, 120);
  });

  initCanvas();
  layoutWeek();
  applyDist();
  applyPos();
  applyNote();
  arm();
  setInterval(sweep, 400);
})();
